export const UNAUTHENTICATED_DESCRIPTION_MODAL: string =
  "RPA Connect needs to update your authentication. Please click the Sign In button to open the authentication window.";

export const FORBIDDEN_DESCRIPTION_MODAL: string =
  "It appears you don't have the required permissions to access this URL. Please double-check your credentials, and if the issue persists, consider signing out and logging in with the correct account";
